import { SmartLink } from "@selector/shared/components";
import { ProjectColoredLink } from "@selector/shared/components";
import type { FC } from "react";
import { CardRowDetail, CardRowDetailColumn, HStack, Icons, InfoToggletip } from "widgets";

import type { Group, Project } from "../../../../graphql.js";

interface ProjectGroupsRowProps {
  project: Project;
  groups: Group[];
}

const ProjectGroupsRow: FC<ProjectGroupsRowProps> = ({ project, groups }) => {
  return (
    <CardRowDetail title={<ProjectColoredLink project={project} forceExternal />}>
      <CardRowDetailColumn>
        {groups.map((group) => (
          <HStack>
            <img src={Icons.Action.SavedItems} width={15} height={15} alt={"Saved Group"} color={"#9DA0A6"} />
            <SmartLink to={`/group/${group.id}`} forceExternal>
              {group.name}
            </SmartLink>
            {group.description && <InfoToggletip title={"Description"} content={group.description} />}
          </HStack>
        ))}
      </CardRowDetailColumn>
    </CardRowDetail>
  );
};

export { ProjectGroupsRow };
